import application from 'application/application';

import template from './processes-details.template.html';

import controller from './processes-details.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.processes.processesDetails', {
				url: '/details?idFonteProc&id&idPastaUsuarioCliente&idUsuarioCliente&idCliente&idGrupo',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Detalhe',
					displayName: 'Detalhe'
				}
			});

	}]);
